(function(global){
"use strict";

var DB_NAME="drive_iq_momentum_library_v2";
var DB_VERSION=1;
var STORE="assets";

function uid(){return "asset_"+Date.now().toString(36)+"_"+Math.random().toString(36).slice(2,9)}
function now(){return new Date().toISOString()}
function kindForFile(file){
  var type=String(file&&file.type||"").toLowerCase();
  if(type.indexOf("video/")===0)return"video";
  if(type.indexOf("image/")===0)return"image";
  return"file";
}

function openDB(){
  return new Promise(function(resolve,reject){
    if(!("indexedDB" in global)){reject(new Error("This browser does not expose IndexedDB."));return}
    var req;
    try{req=global.indexedDB.open(DB_NAME,DB_VERSION)}catch(e){reject(e);return}
    req.onupgradeneeded=function(){
      var db=req.result;
      if(!db.objectStoreNames.contains(STORE)){
        var s=db.createObjectStore(STORE,{keyPath:"id"});
        s.createIndex("feature","feature",{unique:false});
        s.createIndex("kind","kind",{unique:false});
        s.createIndex("createdAt","createdAt",{unique:false});
      }
    };
    req.onsuccess=function(){resolve(req.result)};
    req.onerror=function(){reject(req.error||new Error("Could not open the media library."))};
    req.onblocked=function(){reject(new Error("Media library database is blocked. Close other Drive IQ tabs and retry."))};
  });
}

function runTx(mode,fn){
  return openDB().then(function(db){
    return new Promise(function(resolve,reject){
      var settled=false,t,store;
      try{
        t=db.transaction(STORE,mode);
        store=t.objectStore(STORE);
        fn(store,t);
      }catch(e){
        try{db.close()}catch(_){}
        reject(e);return;
      }
      t.oncomplete=function(){
        if(settled)return;settled=true;
        try{db.close()}catch(_){}
        resolve(true);
      };
      t.onerror=function(){
        if(settled)return;settled=true;
        var err=t.error||new Error("Media library transaction failed.");
        try{db.close()}catch(_){}
        reject(err);
      };
      t.onabort=function(){
        if(settled)return;settled=true;
        var err=t.error||new Error("Media library transaction was aborted.");
        try{db.close()}catch(_){}
        reject(err);
      };
    });
  });
}

function addFile(file,meta){
  meta=meta||{};
  if(!file)return Promise.reject(new Error("No media file was selected."));
  if(!file.size)return Promise.reject(new Error("That media file is empty."));
  var kind=meta.kind||kindForFile(file);
  if(kind==="file")return Promise.reject(new Error("Please choose an image or video file."));
  var asset={
    id:uid(),
    name:meta.name||file.name||"Drive IQ media",
    kind:kind,
    feature:meta.feature||"General",
    tags:Array.isArray(meta.tags)?meta.tags:[],
    approved:meta.approved!==false,
    createdAt:now(),
    size:Number(file.size||0),
    mime:file.type||"",
    duration:Number(meta.duration||0),
    note:meta.note||"",
    blob:file
  };
  return runTx("readwrite",function(store){store.put(asset)}).then(function(){return asset});
}

function addBlob(blob,meta){
  meta=meta||{};
  if(!blob||!blob.size)return Promise.reject(new Error("Generated video is empty."));
  var name=meta.name||("momentum-"+Date.now()+".webm");
  var file;
  try{file=new File([blob],name,{type:blob.type||meta.mime||"video/webm"})}
  catch(e){
    file=blob;
    try{file.name=name}catch(_){}
  }
  return addFile(file,Object.assign({},meta,{name:name,kind:meta.kind||"video"}));
}

function all(){
  return openDB().then(function(db){
    return new Promise(function(resolve,reject){
      var t=db.transaction(STORE,"readonly"),req=t.objectStore(STORE).getAll();
      req.onsuccess=function(){resolve(req.result||[])};
      req.onerror=function(){reject(req.error||new Error("Could not read media assets."))};
      t.oncomplete=function(){try{db.close()}catch(_){}};
    });
  });
}

function get(id){
  return openDB().then(function(db){
    return new Promise(function(resolve,reject){
      var t=db.transaction(STORE,"readonly"),req=t.objectStore(STORE).get(id);
      req.onsuccess=function(){resolve(req.result||null)};
      req.onerror=function(){reject(req.error||new Error("Could not read media asset."))};
      t.oncomplete=function(){try{db.close()}catch(_){}};
    });
  });
}

function remove(id){
  return runTx("readwrite",function(store){store.delete(id)}).then(function(){return true});
}

function update(id,patch){
  return get(id).then(function(asset){
    if(!asset)throw new Error("Asset not found.");
    Object.keys(patch||{}).forEach(function(k){
      if(k!=="id"&&k!=="blob")asset[k]=patch[k];
    });
    return runTx("readwrite",function(store){store.put(asset)}).then(function(){return asset});
  });
}

function findForFeature(feature,opts){
  opts=opts||{};
  return all().then(function(items){
    var f=String(feature||"").toLowerCase(),kind=String(opts.kind||"").toLowerCase();
    return items.filter(function(a){
      if(opts.approved!==false&&a.approved===false)return false;
      if(kind&&String(a.kind||"").toLowerCase()!==kind)return false;
      if(!f)return true;
      var hay=(String(a.feature||"")+" "+String(a.name||"")+" "+(a.tags||[]).join(" ")).toLowerCase();
      return hay.indexOf(f)>=0;
    }).sort(function(a,b){return String(b.createdAt||"").localeCompare(String(a.createdAt||""))});
  });
}

function urlFor(asset){
  if(!asset||!asset.blob)return"";
  try{return URL.createObjectURL(asset.blob)}catch(e){return""}
}

function selfTest(){
  return openDB().then(function(db){
    var info={ok:true,indexedDB:true,dbName:DB_NAME};
    try{db.close()}catch(_){}
    return info;
  }).catch(function(e){
    return {ok:false,indexedDB:!!global.indexedDB,error:String(e&&e.message||e)};
  });
}

global.DriveIQMomentumLibrary={
  version:"V2_IOS_PICKER_FIX",
  addFile:addFile,addBlob:addBlob,all:all,get:get,remove:remove,update:update,
  findForFeature:findForFeature,urlFor:urlFor,kindForFile:kindForFile,selfTest:selfTest
};

})(window);